module.exports = __webpack_public_path__ + "static/media/charu.93c91826.jpg";